export default __webpack_public_path__ + "static/media/roth_401k_dark.6d015717.png";